import React, { useEffect } from "react";
import WOW from "wow.js";
import "./Footer.scss";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import {
  IconBrandFacebook,
  IconBrandFacebookFilled,
  IconBrandLinkedin,
  IconBrandWhatsapp,
  IconBrandXFilled,
  IconLocation,
  IconMail,
  IconMailCheck,
  IconPhoneCall,
} from "@tabler/icons-react";
import nascom from "../Images/NASSCOM Batch.png";
import { useTranslation } from "react-i18next";


function Footer() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);
  const data = [
    {
      text: "Service Offering",
      imageSrc: "image1.jpg",
      alt: "Image 1",
    },
    {
      text: "Service Offering",
      imageSrc: "image2.jpg",
      alt: "Image 2",
    },
    {
      text: "Service Offering",
      imageSrc: "image3.jpg",
      alt: "Image 3",
    },
    {
      text: "Service Offering",
      imageSrc: "image4.jpg",
      alt: "Image 4",
    },
  ];
  const phoneText = t('footer.phonenumber');
  const phoneHref = (phoneText || "").replace(/[^+0-9]/g, "");
  const phoneIndia = t('footer.phonenumber_india');
  const phoneSaudi = t('footer.phonenumber_saudi') || t('footer.phonenumber_secondary');
  const phoneUS = t('footer.phonenumber_us');
  const phoneHrefIndia = (phoneIndia || "").replace(/[^+0-9]/g, "");
  const phoneHrefSaudi = (phoneSaudi || "").replace(/[^+0-9]/g, "");
  const phoneHrefUS = (phoneUS || "").replace(/[^+0-9]/g, "");

  return (
    <>
      <footer className="bg-black text-white  bg-fixed font-sans p-2 "
        id="footerinfo">
        <div className="footer flex justify-around flex-wrap">
          <div className="flex justify-center items-center mt-5 wow fadeInUp rtl:flex-row-reverse">
            <div className="p-2">
              <IconPhoneCall size={40} style={{ color: "#FFFFFF" }} />
            </div>
            <div className="px-3 text-white text-left">
              {i18n?.language && i18n.language.startsWith('en') ? (
                <>
                  <a href={"tel:" + phoneHrefIndia} className="block">
                    <div className="font-semibold text-lg">{t('footer.country_india')}: {phoneIndia}</div>
                  </a>
                  <a href={"tel:" + phoneHrefSaudi} className="block mt-1">
                    <div className="font-semibold text-lg">{t('footer.country_saudi')}: {phoneSaudi}</div>
                  </a>
                  <a href={"tel:" + phoneHrefUS} className="block mt-1">
                    <div className="font-semibold text-lg">{t('footer.country_us')}: {phoneUS}</div>
                  </a>
                  <div className="text-sm  text-left rtl:text-right">{t('footer.hotline')}</div>
                </>
              ) : (
                <>
                  <a href={"tel:" + phoneHref}>
                    <div className="font-semibold text-lg">{phoneText}</div>
                    <div className="text-sm  text-left rtl:text-right">{t('footer.hotline')}</div>
                  </a>
                </>
              )}
            </div>
          </div>
          <div className="flex justify-center items-center mt-5 wow fadeInUp rtl:flex-row-reverse">
            <div className="p-2">
              <IconMailCheck size={40} style={{ color: "#FFFFFF" }} />
            </div>
            <div className="px-3 text-white text-center">
              <a href="mailto:Contactus@corvanta.io">
                <div className="font-semibold text-lg wow fadeInUp text-left rtl:text-right">
                  Contactus@corvanta.io
                </div>
                <div
                  className="text-sm text-left rtl:text-right"
                >
                  {t('footer.freeConsult')}
                </div>
              </a>

            </div>
          </div>
          <div className="flex justify-center items-center mt-5 wow fadeInUp rtl:flex-row-reverse">
            <div className="flex-shrink-0">
              <IconLocation size={40} style={{ color: "#FFFFFF" }} />
            </div>
            <div className="mx-2 text-white rtl:text-right">
              <div className="font-semibold text-lg rtl:text-base rtl:leading-relaxed">
                {i18n?.language && i18n.language.startsWith('en') ? (
                  <>
                    <div className="font-semibold text-lg">{t('footer.country_india')}: </div>
                    <div className="text-sm">{t('footer.address_india')}</div>
                    <div className="mt-2 font-semibold text-lg">{t('footer.country_saudi')}: </div>
                    <div className="text-sm">{t('footer.address_saudi')}</div>

                  </>
                ) : (
                  <>
                    <div>{t('footer.address')}</div>
                    <div className="text-sm">{t('footer.pincode')}</div>
                  </>
                )}
              </div>
            </div>
          </div>


        </div>
        <div className="flex justify-center items-center mt-7 wow fadeInUp ">
          <ScrollLink to="contactus" smooth={true} >
            <div className="text-lg font-semibold cursor-pointer rounded-full shadow-lg bg-[#1B181A] px-3 p-2 text-white">
              {t('footer.getInTouch')}
            </div>
          </ScrollLink>
        </div>
        <div className="mx-10">
          <hr className="my-6 border-[#EF3B3B] sm:mx-auto lg:my-10  " />
        </div>
        <div className="flex justify-between mt-10 mx-4 lg:mx-24 p-5">
          <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 ">
            <div>
              <p className="mb-4 text-left wow fadeInUp">
                {t('footer.companyDescription')}
              </p>
              <div className="flex space-x-4 text-left self-start wow fadeInUp ">
                <SocialLink
                  href="https://www.linkedin.com/company/corvanta-analytics"
                  icon={
                    <IconBrandLinkedin size={25} style={{ color: "#FFFFFF" }} />
                  }
                  label="LinkedIn"
                />
              </div>
            </div>
            <div className="text-left flex flex-col lg:items-center sm:items-start">
              <h4 className="text-lg mr-14 flex flex-col font-bold mb-2 wow fadeInUp ">{t('footer.pages')}</h4>
              <ul className="font-normal text-base cursor-pointer space-y-3 wow fadeInUp lg:items-center sm:items-start">
                <li><ScrollLink to="home" smooth={true} duration={500} spy={true} offset={-70}>&gt; {t('footer.home')}</ScrollLink></li>
                <li><ScrollLink to="aboutus" smooth={true} duration={500} spy={true} offset={-70}>&gt; {t('footer.about')}</ScrollLink></li>
                <li><ScrollLink to="projects" smooth={true} duration={500} spy={true} offset={-70}>&gt; {t('footer.projects')}</ScrollLink></li>
                <li><ScrollLink to="easyflow" smooth={true} duration={500} spy={true} offset={-70}>&gt; {t('footer.easyProcess')}</ScrollLink></li>
                <li><ScrollLink to="nearfuture" smooth={true} duration={500} spy={true} offset={-70}>&gt; {t('footer.nearFuture')}</ScrollLink></li>
              </ul>
            </div>
            <div className="text-left">
              <h4 className="text-lg  ml-3 font-bold mb-2 wow fadeInUp">{t('footer.services')}</h4>
              <ul className="font-normal text-base space-y-3 wow fadeInUp">
                <li> &gt; {t('footer.softwareDevelopment')}</li>
                <li> &gt; {t('footer.aiProgrammer')}</li>
                <li> &gt; {t('footer.systemApplications')}</li>
                <li> &gt; {t('footer.networkSolution')}</li>
              </ul>
            </div>
            <div className="text-left">
              <img src={nascom} alt="" className="-mt-10" />
            </div>
          </div>
        </div>
        <div className="text-center mt-15">
          <div className="flex justify-center gap-6 mb-4">
            <RouterLink
              to="/privacy-policy"
              className="text-sm text-gray-400 hover:text-[#EF3B3B] transition-colors duration-300 underline-offset-4 hover:underline"
            >
              {t('footer.privacyPolicy')}
            </RouterLink>
          </div>
          <p className="text-sm">
            &copy; {new Date().getFullYear()} {t('footer.copyright')}
          </p>
        </div>
      </footer>
    </>
  );
}

const SocialLink = ({ href, icon, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="transform transition flex mb-3 items-center justify-center duration-500 hover:scale-125 text-white hover:text-gray-200 ring-1 ring-[#ffffff] rounded-full h-10 w-10 "
  >
    {icon}
  </a>
);

export default Footer;
